export interface TongueDataItem {
  feature: string
  subtype: string
  tcmState: string
  condition: string
}
export const tongueData: TongueDataItem[] = [
  {
    feature: 'Body Colour',
    subtype: 'Pale & slightly wet',
    tcmState: 'Cold, Yang Qi Xu',
    condition: 'Low Yang energy',
  },
  {
    feature: 'Body Colour',
    subtype: 'Pale & slightly dry',
    tcmState: 'Cold, Xue Xu',
    condition: 'Blood deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Pale on the sides',
    tcmState: 'Liv Xue Xu',
    condition: 'Liver blood deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Orangey sides',
    tcmState: 'Liv Xue Xu severe',
    condition: 'Severe liver blood deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red',
    tcmState: 'Heat',
    condition: 'Heat syndrome',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red w/ coating',
    tcmState: 'Full Heat',
    condition: 'Excess heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red, no coating',
    tcmState: 'Empty Heat',
    condition: 'Yin deficiency with empty heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red tip w/ coating',
    tcmState: 'HT Fire',
    condition: 'Heart fire',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red tip, no coating',
    tcmState: 'HT empty heat',
    condition: 'Heart Yin deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red sides w/ coating',
    tcmState: 'LIV fire / GB heat',
    condition: 'Liver/Gallbladder heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red sides, no coating',
    tcmState: 'LIV empty heat / LIV yin def',
    condition: 'Liver heat/Yin deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red centre w/ coating',
    tcmState: 'Heat in the ST',
    condition: 'Stomach heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red centre, no coating',
    tcmState: 'Empty heat in the ST',
    condition: 'Stomach Yin deficiency',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red points on the tip',
    tcmState: 'HT fire',
    condition: 'Heart fire',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red points on the sides',
    tcmState: 'LIV fire',
    condition: 'Liver fire',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red spots on the root',
    tcmState: 'Heat in lower jiao',
    condition: 'Pelvic organ heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Red points around centre',
    tcmState: 'Stomach heat',
    condition: 'Excess heat in stomach',
  },
  {
    feature: 'Body Colour',
    subtype: 'Spots',
    tcmState: 'Blood Stasis',
    condition: 'Stagnation of blood',
  },
  {
    feature: 'Body Colour',
    subtype: 'Purple',
    tcmState: 'Xue stasis',
    condition: 'Blood stagnation',
  },
  {
    feature: 'Body Colour',
    subtype: 'Reddish purple',
    tcmState: 'Xue stasis (heat)',
    condition: 'Blood stagnation with heat',
  },
  {
    feature: 'Body Colour',
    subtype: 'Bluish purple',
    tcmState: 'Xue stasis (cold)',
    condition: 'Blood stagnation with cold',
  },
  {
    feature: 'Body Colour',
    subtype: 'Sides bluish-purple ♂♀',
    tcmState: 'Liv Xue stasis',
    condition: 'Liver blood stasis',
  },
  {
    feature: 'Body Colour',
    subtype: 'Sides bluish-purple ♀',
    tcmState: 'Bao Xue stasis',
    condition: 'Uterine blood stasis',
  },
  {
    feature: 'Body Colour',
    subtype: 'Centre bluish-purple',
    tcmState: 'ST-Xue stasis',
    condition: 'Stomach blood stasis',
  },
  {
    feature: 'Body Shape',
    subtype: 'Thin-red',
    tcmState: 'Yin deficiency',
    condition: 'Deficient Yin fluids',
  },
  {
    feature: 'Body Shape',
    subtype: 'Thin-pale',
    tcmState: 'Xue deficiency',
    condition: 'Deficient blood',
  },
  {
    feature: 'Body Shape',
    subtype: 'Swollen',
    tcmState: 'Dampness or phlegm',
    condition: 'Retention of fluids',
  },
  {
    feature: 'Body Shape',
    subtype: 'Swollen (red tip)',
    tcmState: 'HT Fire',
    condition: 'Heart fire',
  },
  {
    feature: 'Body Shape',
    subtype: 'Swollen (red sides)',
    tcmState: 'Liv Fire',
    condition: 'Liver fire',
  },
  {
    feature: 'Body Shape',
    subtype: 'Swollen on the sides (pale center)',
    tcmState: 'SP Deficiency',
    condition: 'Spleen deficiency',
  },
  {
    feature: 'Body Shape',
    subtype: 'Swollen in front',
    tcmState: 'Phlegm in LU',
    condition: 'Phlegm in lungs',
  },
  {
    feature: 'Body Shape',
    subtype: 'Stiff',
    tcmState: 'Internal Wind, Xue Stasis',
    condition: 'Wind or blood stasis',
  },
  {
    feature: 'Body Shape',
    subtype: 'Flaccid',
    tcmState: 'Jin-Ye Xu',
    condition: 'Fluids deficiency',
  },
  {
    feature: 'Body Shape',
    subtype: 'Long',
    tcmState: 'Heat',
    condition: 'Internal heat',
  },
  {
    feature: 'Body Shape',
    subtype: 'Short (pale/wet)',
    tcmState: 'Int. cold',
    condition: 'Internal cold',
  },
  {
    feature: 'Body Shape',
    subtype: 'Short (red)',
    tcmState: 'Severe Yin Deficiency',
    condition: 'Yin deficiency',
  },
  {
    feature: 'Body Shape',
    subtype: 'Cracked (centre/sides)',
    tcmState: 'ST/SP Yin Deficiency',
    condition: 'Stomach/Spleen Yin deplete',
  },
  {
    feature: 'Body Shape',
    subtype: 'Cracked (tip)',
    tcmState: 'HT Pattern',
    condition: 'Heart pattern',
  },
  {
    feature: 'Body Shape',
    subtype: 'Quivering',
    tcmState: 'SP Deficiency',
    condition: 'Spleen Qi weak',
  },
  {
    feature: 'Body Shape',
    subtype: 'Deviated',
    tcmState: 'Internal Wind',
    condition: 'Internal wind syndrome',
  },
  {
    feature: 'Body Shape',
    subtype: 'Tooth marks (sides)',
    tcmState: 'SP Qi Deficiency',
    condition: 'Spleen Qi deficiency',
  },
  {
    feature: 'Coating',
    subtype: 'Thin & white (normal)',
    tcmState: '-',
    condition: 'Healthy coating',
  },
  {
    feature: 'Coating',
    subtype: 'Thick',
    tcmState: 'Pathogenic Factor (PF)',
    condition: 'Strong pathogenic factor',
  },
  {
    feature: 'Coating',
    subtype: 'Coating + no root',
    tcmState: 'ST Qi Deficiency',
    condition: 'Stomach Qi deficiency',
  },
  {
    feature: 'Coating',
    subtype: 'Absence of coating',
    tcmState: 'ST Yin Deficiency',
    condition: 'Severe ST/Ki Yin deficiency',
  },
  {
    feature: 'Coating',
    subtype: 'White coating',
    tcmState: 'Cold',
    condition: 'Internal cold',
  },
  {
    feature: 'Coating',
    subtype: 'Grey/black coating',
    tcmState: 'Extreme Cold',
    condition: 'Severe cold',
  },
  {
    feature: 'Moisture',
    subtype: 'Too wet',
    tcmState: 'Yang def. / Damp',
    condition: 'Yang deficiency, Dampness',
  },
  {
    feature: 'Moisture',
    subtype: 'Too dry',
    tcmState: 'Heat / Yin Deficiency',
    condition: 'Heat or Yin deficiency',
  },
  {
    feature: 'Moisture',
    subtype: 'Sticky',
    tcmState: 'Retention of damp/phlegm',
    condition: 'Damp/phlegm retention',
  },
]
